import { render, staticRenderFns } from "./ProvideService.vue?vue&type=template&id=3fc75158&"
import script from "./ProvideService.vue?vue&type=script&lang=ts&"
export * from "./ProvideService.vue?vue&type=script&lang=ts&"
import style0 from "./ProvideService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports